import { render, staticRenderFns } from "./DataDownload.vue?vue&type=template&id=97ed2112&scoped=true&"
import script from "./DataDownload.vue?vue&type=script&lang=js&"
export * from "./DataDownload.vue?vue&type=script&lang=js&"
import style0 from "./DataDownload.vue?vue&type=style&index=0&id=97ed2112&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ed2112",
  null
  
)

export default component.exports